var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"system"},[_c('img',{attrs:{"src":require("../../assets/image/404.png")}}),_c('div',{staticClass:"title"},[_c('h2',[_vm._v("页面走丢了...")]),_c('button',{staticClass:"layui-btn layui-btn-lg layui-btn-normal",attrs:{"type":"button"},on:{"click":_vm.back}},[_vm._v("返回")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }